import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {LanguageService} from '@core/services/language.service';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const languageService = inject(LanguageService);
  const currentLanguage = languageService.getLanguage();
  const acceptLanguage =
    currentLanguage === 'ar' || currentLanguage?.toLowerCase().startsWith('ar')
      ? 'ar,en;q=0.8'
      : 'en,ar;q=0.8';

  const languageReq = req.clone({
    setHeaders: {
      'Accept-Language': acceptLanguage
    }
  });

  return next(languageReq);
};

